import gql from "graphql-tag"

export default gql`
    mutation loginOperator($auth: AuthInput!, $password: String!, $device: CreateDeviceInput) {
        loginOperator(auth: $auth, password: $password, device: $device){
            message
            statusCode
            result{
                token
                refreshToken
                expiresAt
            }
        }
    }
`